<template>
  <div>
    <div v-if="1 ==2">
    <button class="ml-3 mt-3" v-if="showFlag" @click="openSide">
      <v-icon size="28">fas fa-bars</v-icon>
      </button>
      </div>
    <router-view />
  </div>
</template>
<script>
import { EventBus } from "@/services/eventBus";
import localStorageSvc from '@/services/localStorage'
export default {
  data() {
    return {
      showFlag: false,
      siteID: this.$route.params.siteid,
      appID:  this.$route.params.appid
    };
  },
  methods: {
    openSide() {
      EventBus.$emit("openside");
    },
    onResize() {
      let w = window.innerWidth;
      if (w <= 500) {
        this.showFlag = true;
      } else {
        this.showFlag = false;
      }
    }
  },
  created(){
      localStorageSvc.setSiteID(this.siteID);     
      localStorageSvc.setAppID(this.appID);  
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.onResize();
    });
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize());
  }
};
</script>